import script from "./PageBlock1.vue?vue&type=script&setup=true&lang=js"
export * from "./PageBlock1.vue?vue&type=script&setup=true&lang=js"

import "./PageBlock1.vue?vue&type=style&index=0&id=08545666&lang=less"

const __exports__ = script;

export default __exports__